export enum IncomingSampleModals {
  None,
  CollectionSamples,
  UpdateTask,
  UpdateMultipleTasks,
  UpdateCollection,
}
